import { Box } from '@mantine/core';

import { useGetColor } from 'hooks';

import type { IconPropsType } from './types';

export const InProgressIcon = ({
  color,
  size = 24,
  sx,
  ...props
}: IconPropsType) => {
  const iconColor = useGetColor(color);

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 12C20 7.58172 16.4182 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4182 7.58172 20 12 20C16.4182 20 20 16.4182 20 12Z"
        stroke={iconColor}
        strokeLinecap="round"
        strokeDasharray="2 2"
      />
    </Box>
  );
};
